'use strict';

export class MonthlyGiving {
    #header;
	#body;
    #donation_frequency_input;

    constructor() {
        const monthly_giving_modal = document.querySelector('.monthly-giving-modal');
		if (!monthly_giving_modal) return;

		this.#header = monthly_giving_modal.dataset.title;
		this.#body = monthly_giving_modal.innerHTML;
        this.#donation_frequency_input = document.querySelector('#donation_frequency_monthly');

        this.addEvents();
    }

    addEvents() {
		const monthly_giving_modal = document.querySelector('.monthly-giving-modal');
        if(this.#donation_frequency_input) {
			this.#donation_frequency_input.addEventListener('change', async (event) => {
				if(event.target.value === 'monthly') {
					monthly_giving_modal.style.display = '';
					const {Components} = await import('../helpers/Components.js' /* webpackChunkName: "components" */)
					Components.modals()
						.header(`<b>${this.#header}</b>`)
						.body(this.#body)
						.closeOnOutsideClick(true)
						.className('monthly-giving')
						.show()
				}
			});
        }
    }
}
